import { memo, useCallback, useContext } from "react";
import { RESOLUTION } from "app/constants";
import PropTypes from "prop-types";
import waitForFacebookApi from "app/utils/waitForFacebookApi";
import "./MessengerShareLink.scss";
import AppGlobalsContext from "app/AppGlobalsContext";
import { MessengerSvgrepoCom1Icon } from "app/icons/logo";

/**
 * Sur dekstop : on envoie un message Facebook https://developers.facebook.com/docs/sharing/reference/send-dialog
 * sur mobile : on ouvre l'application Messenger https://developers.facebook.com/docs/sharing/messenger
 */
const MessengerShareLink = ({ link, label, onClick, facebookAppID }) => {
	const isFacebookSDKReady = waitForFacebookApi();

	const { resolution } = useContext(AppGlobalsContext);

	const shareOnMessenger = useCallback(() => {
		if (window?.FB?.ui) {
			window.FB.ui(
				{
					method: "send",
					display: "dialog",
					link: link,
				},
				() => {
					if (typeof onClick === "function") {
						onClick();
					}
				}
			);
		}
	}, [link]);

	const shareElement =
		resolution === RESOLUTION.SMALL || resolution === RESOLUTION.MEDIUM ? (
			<a
				className="messenger-share-link"
				href={`fb-messenger://share/?link=${link}&app_id=${facebookAppID}`}
			>
				<span className="messenger-share-link__icon">
					<MessengerSvgrepoCom1Icon height={20} width={20} />
				</span>
				<span className="messenger-share-link__label">{label}</span>
			</a>
		) : (
			<a className="messenger-share-link" onClick={shareOnMessenger}>
				<span className="messenger-share-link__icon">
					<MessengerSvgrepoCom1Icon height={20} width={20} />
				</span>
				<span className="messenger-share-link__label">{label}</span>
			</a>
		);

	return isFacebookSDKReady && shareElement;
};

MessengerShareLink.propTypes = {
	link: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
	label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
	onClick: PropTypes.func,
	facebookAppID: PropTypes.any,
};

export default memo(MessengerShareLink);
